export default "__VITE_ASSET__C2hPeGK9__"